(() => {
  const BUNDLE_PROP = '_ghalia_stack_anchor';
  const FREE_GIFT_PROP = '_ghalia_free_gift';
  const ATTR_KEY = '_ghalia_non_bundle_net';

  const pricing = () => window.GhaliaPricing;

  const isFreeGiftLine = (item) => item?.properties?.[FREE_GIFT_PROP] === 'true';

  const isBundleLine = (item) => Boolean(item?.properties?.[BUNDLE_PROP]);

  const lineNetCents = (item, drawer) => {
    const P = pricing();
    if (!P) return Number(item?.final_line_price ?? item?.line_price ?? 0);
    const row = drawer?.querySelector(`[data-cart-line-key="${item.key}"]`);
    return P.cartLineAmounts(item, row).net;
  };

  const qualifyingSubtotalNet = (cart, drawer) => {
    const P = pricing();
    if (P?.qualifyingSubtotalNet) return P.qualifyingSubtotalNet(cart, drawer);
    let total = 0;
    (cart?.items || []).forEach((item) => {
      if (isFreeGiftLine(item) || isBundleLine(item)) return;
      total += lineNetCents(item, drawer);
    });
    return total;
  };

  const syncCartAttribute = async (cart, drawer) => {
    if (!cart?.items?.length) return cart;
    const net = qualifyingSubtotalNet(cart, drawer);
    const current = cart?.attributes?.[ATTR_KEY];
    const currentNum = current == null || current === '' ? null : Number(current);
    if (currentNum === net) return cart;
    const api = window.GhaliaCartApi;
    if (!api?.updateCart) return cart;
    try {
      const updated = await api.updateCart(
        { attributes: { ...(cart?.attributes || {}), [ATTR_KEY]: String(net) } },
        cart,
        { preserveDiscount: false }
      );
      return updated || cart;
    } catch (err) {
      console.error(err);
      return cart;
    }
  };

  const updatePromoNote = (drawer) => {
    const note = drawer?.querySelector('[data-cart-promo-bundle-note]');
    if (note) note.hidden = true;
  };

  window.GhaliaQualifyingBasket = {
    isBundleLine,
    isFreeGiftLine,
    qualifyingSubtotalNet,
    syncAttribute: syncCartAttribute,
    updatePromoNote,
    ATTR_KEY,
  };
})();
